module.exports = __webpack_public_path__ + "img/Flaticon2.4248a892.svg";